import { ReactElement, useState } from "react";

import styled from "styled-components";

import useModal from "../../hooks/useModal";
import ModalsService from "../../services/modals-service";
import { EModals } from "../../types/enums";
import { Button, Frame, TExtra } from "../ui-kit/styled-templates";
import PopUpWrapper from "./modal-wrapper";

export type TModalityProps = {
    title: string;
    description: ReactElement | string;
    cancelButton: {
        onClick?: Function;
        extra?: TExtra;
        visible?: boolean;
        [key: string]: any;
    };
    confirmButton: {
        onClick?: Function;
        extra?: TExtra;
        visible?: boolean;
        [key: string]: any;
    };
};

const Modality = () => {
    const [data, setData] = useState<TModalityProps>({} as TModalityProps);

    useModal(EModals.Modality, { onOpen: setData });

    const closeModal = () => ModalsService.hideModal(EModals.Modality);

    return (
        <PopUpWrapper name={EModals.Modality} onClickOutside={closeModal}>
            <H2>{data.title}</H2>
            <Frame extra={`width: 100%; align-items: flex-start;`}>{data.description}</Frame>
            <Frame extra={`flex-direction: row; width: 100%; justify-content: flex-end; margin-top: 35px`}>
                {data?.cancelButton?.visible !== false && (
                    <Button
                        variant={`outlined`}
                        {...data?.cancelButton}
                        extra={(data.cancelButton?.extra ?? ``) + `margin-right: 12px;`}
                        onClick={async (e: any) => {
                            try {
                                await data.cancelButton?.onClick?.(e);
                                closeModal();
                            } catch (error) {}
                        }}
                        formNoValidate
                    />
                )}
                {data?.confirmButton?.visible !== false && (
                    <Button
                        {...data.confirmButton}
                        type={`submit`}
                        onClick={async (e: any) => {
                            try {
                                await data.confirmButton?.onClick?.(e);
                                closeModal();
                            } catch (error) {}
                        }}
                    />
                )}
            </Frame>
        </PopUpWrapper>
    );
};

const H2 = styled.h2`
    width: 100%;
    align-items: flex-start;
    margin-bottom: 24px;
`;

export default Modality;
